import React, { Component } from "react";
import { Api } from "../../utils/api";
import Chart from "react-apexcharts";
import moment from "moment";

class FollowupsVsAdmissions extends Component {
  constructor() {
    super();
    this.api = new Api();
  }

  state = {
    chart: {
      title: {
        text: "Admitidos face aos encaminhados",
        align: "center",
        margin: 40,
        style: {
          fontSize: "18px",
          fontWeight: "bold",
          color: "#263238",
        },
      },
      colors: ["#87cefa"],
      plotOptions: {
        radialBar: {
          startAngle: -90,
          endAngle: 90,
          track: {
            background: "#d7f3f7",
            startAngle: -90,
            endAngle: 90,
          },
          dataLabels: {
            name: {
              show: true,
              label: "Admitidos",
            },
            value: {
              show: true,
              fontSize: "18px",
              formatter: function (val) {
                return val + "%";
              },
            },
            total: {
              show: true,
              label: "Admitidos",
            },
          },
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "horizontal",
          gradientToColors: ["#87D4F9"],
          stops: [0, 100],
        },
      },
      stroke: {
        lineCap: "butt",
      },
    },
  };
  render() {
    let admitidos = this.props.followupsVsAdmissions
      ? parseInt(this.props.followupsVsAdmissions[0].admitidos)
      : 0;
    let encaminhados = this.props.followupsVsAdmissions
      ? parseInt(this.props.followupsVsAdmissions[0].encaminhados)
      : 0;
    let nao_admitidos = encaminhados - admitidos;
    let percentagem_admitidos =
      admitidos === 0
        ? 0
        : parseFloat((admitidos * 100) / encaminhados).toFixed(1);

    return (
      <div class="ml-4 mt-3">
        <Chart
          title={this.state.title}
          options={this.state.chart}
          series={[percentagem_admitidos]}
          type="radialBar"
          width="480"
          height="480"
        />
        <br />

        {this.props.filter_date_followups_vs_admissions === null ||
        this.props.filter_date_followups_vs_admissions ===
          moment().subtract(1, "month").format("YYYY-MM-DD") ? (
          <div class="subtitle-grafs text-center">
            <u>Dados referentes aos últimos 30 dias</u>
          </div>
        ) : (
          <div class="subtitle-grafs text-center">
            <u>Dados referentes ao período de tempo referido no filtro</u>
          </div>
        )}
        <div class="subtitle-grafs mt-1 text-center">
          <strong>Número de pedidos admitidos: </strong>
          {admitidos}
        </div>
        <div class="subtitle-grafs text-center">
          <strong>Número de pedidos encaminhados sem admissão: </strong>
          {nao_admitidos}
        </div>
        <div class="subtitle-grafs text-center">
          <strong>Total de pedidos encaminhados: </strong>
          {encaminhados}
        </div>
      </div>
    );
  }
}
export default FollowupsVsAdmissions;
